import { CaseInfoCard } from "./CaseInfoCard";

export default CaseInfoCard;
